import script from "./Siding03HouseWrap.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding03HouseWrap.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__